
























import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IPolicy, IPolicyStep, ITask, StepType } from 'admiral-core';

import 'vue-select/dist/vue-select.css';
import { Util } from '@/utils/Util';
import Avatar from '@/components/common/Avatar.vue';

@Component({
  components: { Avatar },
})
export default class TaskTimeline extends Vue {
  @Prop({ required: true, type: Object })
  task!: ITask;

  timestampStr(step: IPolicyStep) {
    return Util.formatDate(step.createdAt);
  }
  timestampFullStr(step: IPolicyStep) {
    return Util.formatDateFull(step.createdAt);
  }

  get steps() {
    return this.task.steps.sort((a: IPolicyStep, b: IPolicyStep) => {
      if (new Date(a.createdAt).getTime() >= new Date(b.createdAt).getTime()) {
        return -1;
      }

      return 1;
    });
  }

  timelinePointType(step: IPolicyStep) {
    switch (step.type) {
      case StepType.Comment:
        return 'timeline-point-secondary';
      case StepType.Edited:
        return 'timeline-point-secondary';
      case StepType.Created:
        return 'timeline-point-primary';
      case StepType.TransitionOpen:
        return 'timeline-point-info';
      case StepType.TransitionSubmitted:
        return 'timeline-point-warning';
      case StepType.TransitionDeclined:
        return 'timeline-point-danger';
      case StepType.TransitionDeleted:
        return 'timeline-point-danger';
      case StepType.TransitionPoliced:
        return 'timeline-point-success';
    }
  }
}
